import React from "react";
import {
  Box,
  Typography,
  Button,
  useMediaQuery,
  Grid,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EmailIcon from "@mui/icons-material/Email";

const Donate = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [emailOpen, setEmailOpen] = useState(false);

  return (
    <Box sx={{ backgroundColor: "#1d2845", height: "100vh", pt: 4 }}>
      <Box
        sx={{
          maxWidth: isMobile ? "100%" : 1200,
          margin: "0 auto",
          textAlign: "center",
          color: "white",
        }}
      >
        <Box sx={{ mt: 12 }}>
          <script
            src="https://donorbox.org/widget.js"
            paypalExpress="false"
          ></script>
          <Grid
            container
            flexDirection="row"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            <Grid item display="flex" flexDirection="column" xs={7}>
              <Typography variant="h3" sx={{ my: 2, color: "white!important" }}>
                Donate
              </Typography>
              <Typography variant="body"sx={{ my: 2}}>
                Jeremiah Pope is participating in the Montgomery County Public
                Election Fund. This means that he only accepts contributions of
                $500 or less from individuals – no corporations, no PACs, or
                special interests – just you. Your contribution will be matched
                on a sliding scale through the Public Election Fund. If you
                prefer sending your contribution via mail, please send checks to
                "Pope For Council" with this form to Pope For Council, P.O. Box
                4101, Silver Spring, MD 20914.
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <iframe
                title="Donorbox donation form"
                src="https://donorbox.org/embed/popeforcouncil?language=en-us"
                name="donorbox"
                seamless="seamless"
                frameBorder="0"
                height="750px"
                width="425px"
                allow="payment"
              ></iframe>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/* Footer */}
      <footer>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          mt={6}
          mb={4}
          spacing={2}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              sx={{ textTransform: "none", background: "#00853e!important" }}
              onClick={() => setEmailOpen(true)}
            >
              Join Our Email List
            </Button>
          </Grid>
          <Grid item>
            <IconButton
              component="a"
              href="https://instagram.com/popeforcouncil"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton
              component="a"
              href="https://twitter.com/popeforcouncil"
              target="_blank"
              rel="noopener noreferrer"
            >
              <TwitterIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton
              component="a"
              href="https://facebook.com/popeforcouncil"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton
              component="a"
              href="https://www.youtube.com/@JeremiahPopeForCouncil"
              target="_blank"
              rel="noopener noreferrer"
            >
              <YouTubeIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton component="a" href="mailto:info@popeforcouncil">
              <EmailIcon sx={{ color: "white" }} />
            </IconButton>
          </Grid>
          <Grid
            item
            sx={{
              border: "1px solid white",
              padding: ".1rem .5rem !important",
              borderRadius: ".25rem!important",
            }}
          >
            <Typography
              variant="h6"
              sx={{ color: "white", fontSize: "1rem!important" }}
            >
              By Authority: Pope For Council, Angie Logan-Pope, Treasurer
            </Typography>
          </Grid>
        </Grid>
      </footer>
    </Box>
  );
};

export default Donate;
